const STORAGE_KEY = '__v__wl__l__';
const LINK_SELECTOR = '[data-wishlist-header-link]';

function hasWishlistItems() {
  try {
    const wishlist = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');

    return Array.isArray(wishlist.list) && wishlist.list.some((id) => wishlist.items?.[id]?.deleted !== true);
  } catch {
    return false;
  }
}

function syncWishlistHeader() {
  const hasItems = hasWishlistItems();

  document.querySelectorAll(LINK_SELECTOR).forEach((link) => {
    link.classList.toggle('is-wishlist-active', hasItems);
    link.setAttribute('aria-label', hasItems ? 'Önskelista med sparade produkter' : 'Önskelista');
  });
}

function scheduleClickSync(event) {
  const isWishlistAction = event.composedPath().some(
    (element) => element instanceof Element && element.matches('[class*="Wishlist"]')
  );

  if (!isWishlistAction) return;

  requestAnimationFrame(syncWishlistHeader);
  setTimeout(syncWishlistHeader, 150);
  setTimeout(syncWishlistHeader, 500);
}

if (!window.__wishlistHeaderStateInit) {
  window.__wishlistHeaderStateInit = true;

  syncWishlistHeader();
  window.addEventListener('storage', (event) => event.key === STORAGE_KEY && syncWishlistHeader());
  window.addEventListener('focus', syncWishlistHeader);
  document.addEventListener('visibilitychange', () => document.visibilityState === 'visible' && syncWishlistHeader());
  document.addEventListener('click', scheduleClickSync, true);
  document.addEventListener('shopify:section:load', syncWishlistHeader);
}
